import { initialState } from 'acadly/initialState';

import { chainReducers } from '../chainReducers';
import { reducer as courseHandler } from './handlers/course';
import { reducer as syllabusHandler } from './handlers/syllabus';

export const reducer = chainReducers(initialState, courseHandler, syllabusHandler);
